var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transition-login"},[(!_vm.isError)?_c('div',[_vm._v(" 正在跳转中... ")]):_c('div',[_vm._v(" 链接有误，页面出错了！ ")])])}
var staticRenderFns = []

export { render, staticRenderFns }